export default "audio/shot.mp3";